<template>
	<ClientOnly>
		<UModal
			v-model="resultStore.showModalDreams"
			prevent-close
			:ui="{
				overlay: {
					background: 'bg-[#040404D4] bg-opacity-80',
				},
				width: 'w-full sm:max-w-3xl xl:max-w-5xl',
				container: 'items-center',
				padding: 'p-8 sm:p-8',
			}"
		>
			<div class="bg-secondary-700 smm:bg-secondary-900">
				<div class="w-full relative z-10 py-5 sm:py-10 px-4 smm:px-8 sm:px-16 rounded-lg sm:rounded-3xl">
					<BackgroundBanner />
					<div
						v-if="resultStore.loadingModalDreams === false && resultStore.loadingImages === false"
						class="flex justify-end"
					>
						<UButton
							color="white"
							variant="link"
							size="xl"
							icon="i-heroicons-x-mark-20-solid"
							class="text-neutral-50"
							@click="close"
						/>
					</div>
					<div class="w-full space-y-10">
						<div class="flex flex-col 2xl:flex-row gap-6 sm:gap-12 2xl:gap-20">
							<div class="space-y-4 text-neutral-50 text-center smm:text-left 2xl:max-w-80">
								<h2 class="font-semibold text-lg sm:text-3xl">{{ $t('Dream purchases') }}</h2>
								<p class="text-sm sm:text-base">
									{{ $t('See what you could buy today with the jackpot of your chosen lottery') }}.
								</p>
							</div>
							<div class="flex-auto flex flex-col sm:flex-row gap-4">
								<div
									class="rounded-2xl bg-secondary-800 smm:bg-secondary-700 border border-secondary-700 h-24 w-full sm:max-w-64 flex justify-center items-center gap-3"
								>
									<div
										class="relative rounded-full bg-neutral-50 max-w-24 w-full h-8 py-1 flex justify-center items-center"
									>
										<NuxtImg
											:src="`/cdn/${getLottery.image}`"
											:alt="getLottery.name"
											:title="getLottery.name"
											loading="eager"
											layout="fill"
											object-fit="contain"
											class="relative max-h-full h-auto w-auto mx-auto px-5"
										/>
									</div>
									<div>
										<p class="font-semibold text-neutral-50 text-lg">{{ getLottery.name }}</p>
										<p class="text-informative-500">{{ getCountry }}</p>
									</div>
								</div>
								<div
									class="text-neutral-50 rounded-2xl bg-secondary-800 smm:bg-secondary-700 text-lg font-semibold h-24 flex justify-center items-center w-full sm:max-w-64 gap-1"
								>
									<p>
										{{ formatCurrency(resultStore?.getRowSelect?.jackpot, resultStore?.getRowSelect?.type_currency) }}
									</p>
								</div>
							</div>
						</div>
						<LoaderResults v-if="resultStore.loadingModalDreams" />
						<template v-else>
							<div class="space-y-12 smm:hidden">
								<template
									v-for="(prize, index) in resultStore.getDream?.prizes"
									:key="index"
								>
									<CardPrize
										:content="prize"
										:loading="resultStore.loadingImages"
									/>
								</template>
							</div>
							<UCarousel
								v-slot="{ item }"
								:items="resultStore.getDream?.prizes"
								:ui="{ item: 'smm:max-w-80', container: 'gap-10' }"
								class="hidden smm:block"
							>
								<CardPrize
									:content="item"
									:loading="resultStore.loadingImages"
								/>
							</UCarousel>
						</template>
					</div>
				</div>
			</div>
		</UModal>
	</ClientOnly>
</template>

<script setup>
import BackgroundBanner from '~/components/effects/BackgroundBanner'
import CardPrize from '~/components/pages/results/tabs/results/CardPrize'
import LoaderResults from '~/components/pages/results/LoaderResults'
import { useResultStore } from '~/store/result'
import { fetchLotterySelect } from '~/utils/playLottery.js'

const resultStore = useResultStore()

defineOptions({
	name: 'ModalDreams',
})

const getLottery = computed(() => {
	if (resultStore.lottery_id === null) return null
	return fetchLotterySelect(resultStore.lottery_id)
})

const getCountry = computed(() => {
	if (resultStore.country === null) return null
	return resultStore.country?.label
})

const close = () => {
	resultStore.SET_STATE_RESULT({
		type: 'showModalDreams',
		value: false,
	})
}
</script>
